import * as React from "react";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../../less/IdStyles";
import { selectIsOfferPurchased } from "../../../selectors/selectPaymentEntryInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { ButtonListGreen } from "../../generic/common/ButtonListGreen";
import { ProductionTransitionArrow } from "../../generic/common/ProductionTransitionArrow";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { List } from "../../generic/list/List";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionExpenseConfirmed } from "../../item-packages/actionPackages";
import { TooltipText } from "../../tooltip";
var _OfferLevelRewardListItem = function (_a) {
    var levelReward = _a.levelReward, hasBeenCollected = _a.hasBeenCollected, isEnabled = _a.isEnabled, isOfferPurchased = _a.isOfferPurchased, onCollect = _a.onCollect, onTryCollect = _a.onTryCollect;
    var resourceRewards = levelReward.resourceReward, requPlayerLevel = levelReward.requPlayerLevel;
    var replacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(requPlayerLevel || 0)],
    ]);
    var collectionState = getCollectionState(levelReward, isOfferPurchased, hasBeenCollected, isEnabled, function () { return onCollect(levelReward.id, true); }, onTryCollect);
    return (React.createElement("div", { className: IdStyles.OfferLevelRewardListItem + " offer-level-reward-item" },
        React.createElement("div", { className: "offer-level-reward-item__title" },
            React.createElement(TextLoca, { id: IdLoca.reachLevelX, replacements: replacements, className: IdStyles.TextBoldPrimary })),
        React.createElement("div", { className: "offer-level-reward-item__arrow" },
            React.createElement(ProductionTransitionArrow, null)),
        React.createElement("div", { className: "offer-level-reward-item__reward" },
            React.createElement("div", { className: IdStyles.OfferLevelRewardContainer },
                React.createElement(List, { items: resourceRewards || [], renderItem: renderReward, className: "flex flex--around" }))),
        React.createElement("div", { className: "offer-level-reward-item__collect" }, collectionState)));
};
var getCollectionState = function (levelReward, hasBeenBought, hasBeenCollected, isEnabled, onCollect, onTryCollect) {
    if (hasBeenCollected) {
        return React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconMedium });
    }
    var onClick = hasBeenBought ? onCollect : isEnabled ? onTryCollect : function () { return undefined; };
    return getButtonElement(isEnabled, onClick, levelReward.requPlayerLevel || 0, hasBeenBought);
};
var getButtonElement = function (isEnabled, onClick, requiredLevel, isBought) {
    var button = (React.createElement(ButtonListGreen, { disabled: !isBought || !isEnabled, onClick: onClick },
        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })));
    if (isEnabled) {
        if (!isBought) {
            return button;
        }
    }
    else {
        var reqPlayerLevelString = requiredLevel ? utilNumber.format(requiredLevel) : "0";
        var replacements = new Map([[ReplacementLoca.zero_0, reqPlayerLevelString]]);
        return (React.createElement(TooltipText, { id: IdLoca.floatingText_levelCap, replacements: replacements }, button));
    }
    return button;
};
var renderReward = function (resourceReward) {
    if (resourceReward == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var resource = selectResourceInfo(resourceReward.resourceId);
    var icon = getResourceIcon(resource);
    return (React.createElement("div", { className: "flex flex--guts", key: resourceReward.resourceId + "-" + resourceReward.amount },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
        React.createElement(NumberFormat, { amount: resourceReward.amount, className: IdStyles.TextBoldPrimary })));
};
var mapState = function (state, ownProps) { return ({
    isOfferPurchased: selectIsOfferPurchased(state, ownProps.offerCharacteristicId),
}); };
var mapDispatch = function (dispatch) { return ({
    onCollect: function (packageId) { return dispatch(actionExpenseConfirmed(packageId)); },
}); };
export var OfferLevelRewardListItem = connect(mapState, mapDispatch)(_OfferLevelRewardListItem);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferLevelRewardListItem.tsx
// module id = 2916
// module chunks = 3